<template>
    <!-- :card-data="data" -->
  <card-template
    :card-title="data.cardName"
    :is-loading="isLoading"
    :card-info="getCardInfo()"
    card-type="GENERATOR"
  ></card-template>
</template>

<script>
import CardTemplate from './card-template.vue'
export default {
  name: 'card-generator',
  methods: {
    getCardInfo () {
      return {
        lightColor: 'red',
        cardNumber: '99+',
        message: 'Errores y advertencias al generar reportes'
      }
    }
  },
  props: {
    isLoading: {
      type: Boolean,
      default () {
        return true
      }
    },
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  components: {
    CardTemplate
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/supervisor/card-generator.vue